/* Preserve HD sources. Fetch deferred videos near the viewport, and play only
   when visible. Closed accordions and offscreen carousel cards stay unloaded. */
(function () {
  if (window.KoperoVideoVisibility) return;
  var players = new Map();
  var scheduled = false;

  function inArea(video, margin, minimum, requirePaint) {
    if (document.hidden || !video.isConnected) return false;
    var rect = video.getBoundingClientRect();
    if (!rect.width || !rect.height) return false;
    var left = Math.max(0, rect.left), right = Math.min(innerWidth, rect.right);
    var top = Math.max(-margin, rect.top), bottom = Math.min(innerHeight + margin, rect.bottom);
    for (var el = video; el; el = el.parentElement) {
      if (el.hidden || (el.tagName === 'DETAILS' && !el.open)) return false;
      var css = getComputedStyle(el);
      if (css.display === 'none' || css.visibility === 'hidden' || css.visibility === 'collapse' || (requirePaint && Number(css.opacity) === 0)) return false;
      if (el !== video && /hidden|clip|scroll|auto/.test(css.overflowX + css.overflowY)) {
        var clip = el.getBoundingClientRect();
        if (/hidden|clip|scroll|auto/.test(css.overflowX)) {
          left = Math.max(left, clip.left); right = Math.min(right, clip.right);
        }
        if (/hidden|clip|scroll|auto/.test(css.overflowY)) {
          top = Math.max(top, clip.top); bottom = Math.min(bottom, clip.bottom);
        }
      }
    }
    return Math.max(0, right - left) * Math.max(0, bottom - top) >= rect.width * rect.height * minimum;
  }

  function isVisible(video) {
    return inArea(video, 0, 0.25, true);
  }

  function prepare(video) {
    var poster = video.getAttribute('data-kopero-video-poster');
    if (poster && video.getAttribute('poster') !== poster) video.setAttribute('poster', poster);
    var source = video.getAttribute('data-kopero-video-src');
    if (!source || video.getAttribute('src') === source) return;
    // The URL is the original HD file from Liquid; no transcoding or resizing.
    video.setAttribute('src', source);
    video.setAttribute('preload', 'metadata');
    video.load();
  }

  function update() {
    scheduled = false;
    players.forEach(function (state, video) {
      if (!video.isConnected) {
        video.pause();
        if (observer) observer.unobserve(video);
        players.delete(video);
        return;
      }
      // Start the request up to 400px ahead of scrolling into view. Do not
      // wait for the reveal animation, but keep hidden/closed content deferred.
      if (inArea(video, 400, 0.01, false)) prepare(video);
      var visible = isVisible(video);
      if (!visible) video.pause();
      else if (!state.visible) state.play();
      state.visible = visible;
    });
  }

  function refresh() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }

  var observer = window.IntersectionObserver ? new IntersectionObserver(refresh, { rootMargin: '400px 0px', threshold: [0, 0.25, 1] }) : null;

  function register(video, play) {
    if (players.has(video)) return;
    video.setAttribute('data-kopero-visible-video', '');
    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.pause();
    // A deferred video is already at zero. Seeking it here can trigger an
    // unnecessary network request; only reset legacy media already playing.
    if (!video.hasAttribute('data-kopero-video-src') && video.currentTime > 0) {
      try { video.currentTime = 0; } catch (e) { /* Not loaded yet. */ }
    }
    var state = { visible: false, play: play };
    players.set(video, state);
    video.addEventListener('play', function () {
      if (!isVisible(video)) video.pause();
    });
    video.addEventListener('loadeddata', function () {
      if (isVisible(video)) play();
      else video.pause();
    });
    if (observer) observer.observe(video);
    refresh();
  }

  window.KoperoVideoVisibility = { register: register, isVisible: isVisible, refresh: refresh };
  document.addEventListener('scroll', refresh, { capture: true, passive: true });
  document.addEventListener('toggle', refresh, true);
  document.addEventListener('transitionend', refresh, true);
  document.addEventListener('animationend', refresh, true);
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('resize', refresh, { passive: true });
  window.addEventListener('pageshow', refresh);
})();
